/* eslint-disable no-console */
import { cloneDeep } from 'lodash';
import { GATEWAY_API_HOST, GATEWAY_API_PORT, GATEWAY_API_PROTOCOL } from '../constants/api';

const isCarbonizerServer = (apiUrl) => {
  if (!apiUrl) return false;
  let url = `${GATEWAY_API_PROTOCOL}//${GATEWAY_API_HOST}:${GATEWAY_API_PORT}`;
  if (!GATEWAY_API_PORT) {
    url = `${GATEWAY_API_PROTOCOL}//${GATEWAY_API_HOST}`;
  }
  if (apiUrl.includes(url)) return true;
  return false;
};

const errorResponse = (dispatch, err, type, url) => {
  let message;
  let updatedType = cloneDeep(type);
  if (!err.response) {
    console.error(`ERROR RESPONSE - NETWORK ERROR for ${type}`);
    message = 'Network Error. Unable to connect to server.';
  } else {
    const { response } = err;

    switch (response.status) {
      case 403:
        console.error(`ERROR RESPONSE - PERMISSION ERROR for ${type}: `, response.data);
        updatedType = `${type}_DENIED`;
        ({ message } = response.data);
        break;
      case 404:
        console.error(`ERROR RESPONSE - ROUTE ERROR for ${type}: `, response.data);
        message = 'Route Error. Unable to find route on server';
        break;
      case 401:
        console.error(`ERROR RESPONSE - AUTHENTICATION ERROR for ${type}: `, response.data);
        ({ message } = response.data);
        if (isCarbonizerServer(url)) {
          dispatch({ type: 'AUTHENTICATION_ERROR', payload: message });
        }
        break;
      default:
        console.error(`ERROR RESPONSE - APPLICATION ERROR for ${type}: `, response.data);
        message =
          response.data.message !== undefined
            ? response.data.message
            : 'Application Error. Unknown failure occurred';
        break;
    }
  }
  dispatch({ type: updatedType, payload: message, data: err?.response?.data || {} });
  return {
    success: false,
    message,
  };
};

export default errorResponse;
